function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { WayfindingCardArticle as WayfindingCardArticle$1, formatDateWithoutTimeZone, Wayfinding } from '@cbhq/cdx-components';
import { getComposeEntryProps } from '../globals/composePage.js';
import { mapEntryLink } from '../globals/navlink.js';
import { getEntryProps } from '../utils/getEntryProps.js';
import { getEntryTypeId } from '../utils/getEntryTypeId.js';
import { jsx } from 'react/jsx-runtime';
const WAYFINDING_CARD_ARTICLE_CONTENT_MODEL_ID = 'cdxWayfindingArticleCardGrid';
const COMPONENT_CARD_ARTICLE_CONTENT_MODEL_ID = 'cdxComponentCardArticle';
function WayfindingCardArticle({
  headline,
  body,
  link,
  hasSpacingTop = true,
  columns = 3,
  rows = 2,
  cards = [],
  hideDescriptions,
  descriptionsMaxLines = 'all',
  style,
  anchor,
  aspectRatio,
  hasSpacingHorizontal = true,
  as,
  options
}) {
  const linkProps = link ? mapEntryLink(link) : undefined;
  const articleCards = useMemo(() => {
    return cards.map((entry, index) => {
      const isCard = getEntryTypeId(entry) === COMPONENT_CARD_ARTICLE_CONTENT_MODEL_ID;
      if (isCard) {
        const _getEntryProps = getEntryProps(entry),
          headline = _getEntryProps.headline,
          body = _getEntryProps.body,
          thumbnail = _getEntryProps.thumbnail,
          link = _getEntryProps.link,
          url = _getEntryProps.url;
        const navLink = link && mapEntryLink(link).url;
        return /*#__PURE__*/jsx(WayfindingCardArticle$1, {
          headline: headline || '',
          maxLines: descriptionsMaxLines !== 'all' ? Number(descriptionsMaxLines) : undefined,
          body: hideDescriptions ? undefined : body || '',
          mediaUrl: thumbnail?.fields.file?.url,
          mediaAlt: thumbnail?.fields?.title,
          href: navLink || url,
          style: style
        }, index);
      } else {
        const _getComposeEntryProps = getComposeEntryProps(entry),
          headline = _getComposeEntryProps.headline,
          excerpt = _getComposeEntryProps.excerpt,
          composeSlug = _getComposeEntryProps.composeSlug,
          image = _getComposeEntryProps.image,
          readTime = _getComposeEntryProps.readTime,
          tags = _getComposeEntryProps.tags,
          publicationDate = _getComposeEntryProps.publicationDate;
        const firstTag = tags?.find(tag => tag.fields.type !== 'internal');
        const _getEntryProps2 = getEntryProps(firstTag),
          label = _getEntryProps2.label,
          link = _getEntryProps2.link;
        const tagLink = mapEntryLink(link);
        return /*#__PURE__*/jsx(WayfindingCardArticle$1, {
          headline: headline || '',
          maxLines: 2,
          body: hideDescriptions ? '' : excerpt,
          href: composeSlug,
          mediaUrl: image?.fields.file.url || options?.fallbackImageUrl,
          mediaAlt: image?.fields.title || options?.fallbackImageAlt,
          datePublished: formatDateWithoutTimeZone(publicationDate, {
            month: 'short',
            year: 'numeric',
            day: 'numeric'
          }),
          readTime: readTime,
          tagLabel: label,
          tagHref: tagLink.url && `/${tagLink.url}`
        }, index);
      }
    });
  }, [cards, hideDescriptions, descriptionsMaxLines, style, options]);
  if (!articleCards || articleCards.length === 0) return null;
  return /*#__PURE__*/jsx(Wayfinding, _objectSpread(_objectSpread({
    headline: headline,
    body: body,
    columns: columns,
    rows: rows,
    aspectRatio: aspectRatio,
    style: style,
    hasSpacingTop: hasSpacingTop,
    hasSpacingHorizontal: hasSpacingHorizontal,
    as: as,
    anchor: anchor,
    ctaButtonLabel: linkProps?.label,
    ctaButtonUrl: linkProps?.url && `/${linkProps?.url}`
  }, options), {}, {
    children: articleCards
  }));
}
export { COMPONENT_CARD_ARTICLE_CONTENT_MODEL_ID, WAYFINDING_CARD_ARTICLE_CONTENT_MODEL_ID, WayfindingCardArticle };
//# sourceMappingURL=WayfindingCardArticle.js.map
